import store from '@platform-shared/store'
import surveys from './surveys'

store.registerModule('surveys', surveys)

export default store
